<template>
  <auth-card>
    <v-card-text>
      <validation-observer
        ref="formRecoveryPassword"
        autocomplete="off"
        tag="form"
        @keyup.enter="update()"
      >
        <validation-provider
          v-slot="{ errors }"
          name="E-mail"
          rules="required|email"
          vid="email"
        >
          <v-text-field
            v-model="email"
            :error-messages="errors"
            outlined
            dense
            label="E-mail"
          />
        </validation-provider>

        <v-alert
          :icon="icons.mdiInformationOutline"
          text
          outlined
          color="info"
        >
          Após clicar no botão <b>Enviar</b>, você receberá um e-mail contendo um link para redefinir sua senha.
        </v-alert>

        <v-btn
          block
          class="auth-cta"
          @click="update()"
        >
          Enviar
        </v-btn>
      </validation-observer>
    </v-card-text>

    <v-card-text class="d-flex align-center justify-center flex-wrap mt-2">
      <span class="me-2">
        Já tem uma conta?
      </span>
      <router-link :to="{ name:'signin' }">
        Faça login
      </router-link>
    </v-card-text>
  </auth-card>
</template>

<script>
import { mdiInformationOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { mapActions } from 'vuex'
import AuthCard from '@/views/auth/components/AuthCard.vue'

const REDIRECT_DELAY_MS = 3000

export default {
  components: {
    AuthCard,
  },

  setup() {
    const email = ref('')

    return {
      email,
      icons: {
        mdiInformationOutline,
      },
    }
  },

  beforeDestroy() {
    clearTimeout(this.redirectTimer)
    this.$loading(false)
  },

  methods: {
    ...mapActions('auth', [
      'recoveryPassword',
    ]),

    async update() {
      if (!(await this.$refs.formRecoveryPassword.validate())) return

      this.$loading(true)

      // Sem await: se o servidor demorar ou falhar no envio do e-mail, o usuario
      // nao pode ficar preso no overlay, que e persistente e nao pode ser fechado.
      this.recoveryPassword({ email: this.email })

      this.redirectTimer = setTimeout(() => {
        this.$loading(false)
        this.$router.push('/signin')
      }, REDIRECT_DELAY_MS)
    },
  },
}
</script>
